import { FunctionComponent, useEffect } from 'react';

export const SuspenseStateTransmitter: FunctionComponent<{
    setLoading: (val: boolean) => any;
}> = ({ setLoading }) => {
    useEffect(() => {
        setLoading(true);

        return () => {
            setLoading(false);
        };
    }, []);

    return null;
};
